import gql from 'graphql-tag';

const NAME =
  'compositions_CaseRequestsPanel_RequestAssetsForm_createPrimaryAssetMutation';

export default gql`
  mutation ${NAME} ($caseId: ID! $asset: AssetParams!) {
    createPrimaryAsset(input: { caseId: $caseId, assetParams: $asset }) {
      asset {
        id
        unitNumber
        droppedUnit
        assetType
        trailerType
        canDelete
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestsPanelContext/withRequestAssetActions/createPrimaryAssetMutation.js